import { css } from "lit";

export const notificationManagerStyles = css`
  :host {
    /* Remove fixed positioning - popover will handle positioning */
    display: contents;
  }

  .notification-container {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-400);
    pointer-events: auto;

    /* Top layer positioning */
    position: fixed;
    z-index: 10000; /* Top layer doesn't need z-index */

    /* Default styles for popover */
    margin: 0;
    padding: 0;
    border: none;
    background: transparent;
    overflow: visible;
  }

  /* Desktop positioning: top-right */
  @media (min-width: 768px) {
    .notification-container {
      top: 16px;
      right: 16px;
      left: auto;
      width: 350px;
    }
  }

  /* Mobile positioning: full-width top */
  @media (max-width: 767px) {
    .notification-container {
      top: 0;
      left: 0;
      right: 0;
      width: 100%;
      gap: var(--sds-size-space-300);
    }
  }
`;
